import { PortfolioItem } from 'portfolio/PortfolioItem';
import isNil from 'lodash/isNil';
import { PortfolioReturnsConfigurationState } from 'widgets/portfolioReturns/store/configuration/PortfolioReturnsConfigurationState';
import { selectAppSettings } from 'app/store/appSettings/selectors';
import { buildPortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';
import State from 'store/State';

const {
    selectors: { selectConfigState },
} = buildPortfolioReturnsConfigSlice();

export function filterPortfolio(
    filteredPortfolio: PortfolioItem[],
    config: PortfolioReturnsConfigurationState
): PortfolioItem[] {
    const { useAvgExecPrice } = config;

    const filter = useAvgExecPrice ? avgExecPriceFilter : () => true;
    return filteredPortfolio.filter(filter);
}

export function avgExecPriceFilter(item: PortfolioItem): boolean {
    // Exclude orders with a non-zero traded quantity (fillQty order field) which don't also have a dollar average execution price (avgPxC) order field set
    return !(item.qtyTraded > 0 && isNil(item.averagePrice));
}

export interface AverageExecPriceBenchmarkReferenceValues {
    buy: number;
    sell: number;
    short: number;
}

export function computeAverageExecPriceBenchmarkReferenceValues(
    portfolio: PortfolioItem[],
    state: State,
    widgetKey: string
): AverageExecPriceBenchmarkReferenceValues | undefined {
    const config = selectConfigState(state, widgetKey);

    if (!config.useAvgExecPrice) {
        return undefined;
    }

    const filteredPortfolio = filterPortfolio(portfolio, config);
    const { combineSellsAndShorts } = selectAppSettings(state);

    const result: AverageExecPriceBenchmarkReferenceValues = {
        buy: 0,
        sell: 0,
        short: 0,
    };

    return filteredPortfolio.reduce((res, item) => {
        if (item.side === 'B') {
            res.buy = res.buy + item.qtyTraded * item.averagePrice;
        }
        if (item.side === 'S') {
            res.sell = res.sell + item.qtyTraded * item.averagePrice;
        }
        if (item.side === 'SS' && combineSellsAndShorts) {
            res.sell = res.sell + item.qtyTraded * item.averagePrice;
        }
        if (item.side === 'SS' && !combineSellsAndShorts) {
            res.short = res.short + item.qtyTraded * item.averagePrice;
        }
        return res;
    }, result);
}
